export const COLOR_POPUP_MODE = {
    COLOR: 'mode-color',
    COLOR_BAR: 'mode-color-bar',
    BACKGROUND: 'mode-background',
};
